/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_No_SubscriptionsInputs */

const en_admin_subscriptions_no_subscriptions = /** @type {(inputs: Admin_Subscriptions_No_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscriptions yet`)
};

const zh_admin_subscriptions_no_subscriptions = /** @type {(inputs: Admin_Subscriptions_No_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无订阅记录`)
};

/**
* | output |
* | --- |
* | "No subscriptions yet" |
*
* @param {Admin_Subscriptions_No_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_no_subscriptions = /** @type {((inputs?: Admin_Subscriptions_No_SubscriptionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_No_SubscriptionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_no_subscriptions(inputs)
	return zh_admin_subscriptions_no_subscriptions(inputs)
});
export { admin_subscriptions_no_subscriptions as "admin.subscriptions.no_subscriptions" }